import { faCopy, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import Icon from '@veeva/corgix/icon';
import Popconfirm from '@veeva/corgix/popconfirm';
import PropTypes from 'prop-types';
import { useState } from 'react';
import {
    customerStatFilterButtonsCSS,
    customerStatFilterDisabledButtonsCSS,
    customerStatFilterEditDeleteCSS,
    customerStatFilterEditDeleteHiddenCSS,
    customerStatFilterPopConfirmCSS,
    deleteSpanCSS,
} from './styles/CustomerStatFilterSavedFiltersSelection.styles';

export default function CustomerStatFilterRadioCopyDeleteButtons({
    isSelectedFilter,
    filterName,
    handleCopyClick,
    handleDeleteClick,
    handleHoverCopyClick,
    handleHoverDeleteClick,
    mobile,
    canCopy,
}) {
    const [open, setOpen] = useState(false);
    const handleCancel = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };

    const handleConfirm = (name) => {
        if (name) {
            handleHoverDeleteClick(name);
        } else {
            handleDeleteClick();
        }
        setOpen(false);
    };

    if (isSelectedFilter) {
        return (
            <span css={customerStatFilterEditDeleteCSS}>
                {canCopy ? (
                    <button
                        onClick={handleCopyClick}
                        type="button"
                        css={customerStatFilterButtonsCSS}
                    >
                        <Icon title="Copy" size="xs" type={faCopy} />
                    </button>
                ) : (
                    <button type="button" css={customerStatFilterDisabledButtonsCSS} disabled>
                        <Icon size="xs" type={faCopy} />
                    </button>
                )}
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <span
                    onClick={(e) => {
                        // Add stop propagation so that clicking it won't bubble up to other components such as changing the radio value
                        e.stopPropagation();
                    }}
                    css={deleteSpanCSS}
                >
                    <Popconfirm
                        size={mobile ? 'sm' : 'md'}
                        placement="left"
                        description={`Delete ${filterName}?`}
                        onConfirm={handleConfirm}
                        onCancel={handleCancel}
                        open={open}
                        css={customerStatFilterPopConfirmCSS}
                    >
                        <button
                            onClick={handleOpen}
                            type="button"
                            css={customerStatFilterButtonsCSS}
                        >
                            <Icon title="Delete" size="xs" type={faTrashCan} />
                        </button>
                    </Popconfirm>
                </span>
            </span>
        );
    }
    if (!mobile) {
        return (
            <span css={customerStatFilterEditDeleteHiddenCSS}>
                {canCopy ? (
                    <button
                        onClick={(e) => handleHoverCopyClick(e, filterName)}
                        type="button"
                        css={customerStatFilterButtonsCSS}
                    >
                        <Icon title="Copy" size="xs" type={faCopy} />
                    </button>
                ) : (
                    <button type="button" css={customerStatFilterDisabledButtonsCSS} disabled>
                        <Icon size="xs" type={faCopy} />
                    </button>
                )}
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <span
                    onClick={(e) => {
                        // Add stop propagation so that clicking it won't bubble up to other components such as changing the radio value
                        e.stopPropagation();
                    }}
                    css={deleteSpanCSS}
                >
                    <Popconfirm
                        size="sm"
                        placement="left"
                        description={`Delete ${filterName}?`}
                        onConfirm={() => handleConfirm(filterName)}
                        onCancel={handleCancel}
                        open={open}
                        css={customerStatFilterPopConfirmCSS}
                    >
                        <button
                            onClick={handleOpen}
                            type="button"
                            css={customerStatFilterButtonsCSS}
                        >
                            <Icon title="Delete" size="xs" type={faTrashCan} />
                        </button>
                    </Popconfirm>
                </span>
            </span>
        );
    }
    return '';
}

CustomerStatFilterRadioCopyDeleteButtons.propTypes = {
    canCopy: PropTypes.bool,
    filterName: PropTypes.string,
    handleCopyClick: PropTypes.func,
    handleDeleteClick: PropTypes.func,
    handleHoverCopyClick: PropTypes.func,
    handleHoverDeleteClick: PropTypes.func,
    isSelectedFilter: PropTypes.bool,
    mobile: PropTypes.bool,
};
